



































import Vue from "vue";
import Component from "vue-class-component";
import SpinnerComponent from "../ui/spinner.component.vue";
import NetReviewsReview from "./net-reviews-review.component.vue";
import netReviewsService from "./net-reviews.service";
import { Review } from "./review";

@Component({
  props: {
    productReference: String,
  },
  components: {
    review: NetReviewsReview,
    spinner: SpinnerComponent,
  },
})
export default class NetReviewsProductReviews extends Vue {
  productReference: string;
  loading = true;
  error: string = null;
  reviews: Review[] = [
    /*
    { id: "1", firstName: "prenom_1", lastName: "nom_1", content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.", rate: 3, date: new Date() },
    { id: "1", firstName: "prenom_1", lastName: "nom_1", content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.", rate: 5, date: new Date() },
    { id: "1", firstName: "prenom_1", lastName: "nom_1", content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.", rate: 0, date: new Date() }
    */
  ];

  mounted() {
    (async () => {
      this.loading = true;
      try {
        this.reviews = await netReviewsService.getProductReviews(
          this.productReference
        );
      } catch (e) {
        this.error = "ERROR";
      } finally {
        this.loading = false;
      }
    })();
  }
}
